import { render, staticRenderFns } from "./NewsCategoriesTable.vue?vue&type=template&id=3e520416&"
import script from "./NewsCategoriesTable.vue?vue&type=script&lang=js&"
export * from "./NewsCategoriesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports